import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=f8c282e6&"
import script from "./UsersPage.vue?vue&type=script&lang=js&"
export * from "./UsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports